import styled from 'styled-components';

export const LocationRuleConditionStyled = styled.div`
  .wrap-button {
    min-width: 110px;
  }
`;
